import React, { HTMLAttributes } from 'react';
import { Keys } from '../../../../types/keys';
import { AriaNode } from './view';

interface IAriaNodeProps {
  tagName?: string;
}
export class AriaNodeController extends React.Component<IAriaNodeProps & HTMLAttributes<'button'>> {
  static defaultProps = {
    tagName: 'div',
  };

  elementRef = null;

  createRef = () => {
    this.elementRef = React.createRef<any>();
    return this.elementRef;
  };

  public focusElement = () => this.elementRef.current.focus();

  private handleKeyPress = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (![Keys.ENTER, Keys.SPACE].includes(e.charCode)) {
      return null;
    }
    if (this.props.onKeyPress) {
      this.props.onKeyPress(e);
    }
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  render() {
    return (
      <AriaNode
        tagName={this.props.tagName}
        onKeyPress={this.handleKeyPress}
        createRef={this.createRef}
        {...this.props}
      />
    );
  }
}
